import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/purple-ventures/src/components/landing/sections/HowItWorksSection.tsx");
